import {
	IVervAPIServices,
	BiDataRequest,
	Success,
	UserPromocode,
	Status,
} from '../../services/VervAPI';
import {
	IAnalyticsEventsTracker,
	IAnalyticsEvent,
	AnalyticsEventsTrackerError,
} from '@verv-inc/js-toolkit';
import { IExtraDataPromocode } from 'types';

export interface StateData {
	extraDataPromocode?: IExtraDataPromocode;
	sourceLocation: Location;
}

export interface Props {
	api: IVervAPIServices;
	bundleID: string;
	extraDataPromocodeLifeInterval: number;
	getStateData: () => StateData;
	updateStateData: (extraDataPromocode: IExtraDataPromocode | null) => void;
}

export const VervBIEventsTracker = (props: Props): IAnalyticsEventsTracker => {
	const { api, bundleID, extraDataPromocodeLifeInterval, getStateData, updateStateData } = props;

	const biDataRequestComposer = (
		eventName: string,
		extraDataPromocode: IExtraDataPromocode | undefined,
		sourceLocation: Location,
	): BiDataRequest => {
		const promocode: string | null =
			extraDataPromocode != null && extraDataPromocode?.promocode !== 'undefined'
				? extraDataPromocode?.promocode
				: null;
		return {
			bundle_id: bundleID,
			...(promocode && { promocode }),
			extra_data: {
				source_url: sourceLocation.href,
				bi_data: {
					[eventName]: true,
				},
			},
		};
	};

	return {
		async track(event: IAnalyticsEvent) {
			if (!api) throw AnalyticsEventsTrackerError.NOT_INITIALIZED('VervBIEventsTracker');

			const { extraDataPromocode, sourceLocation } = getStateData();

			// if promocode exists, check it's expiration
			if (extraDataPromocode != null) {
				const promocodeLifetime = Date.now() - extraDataPromocode.timestamp; // milliseconds
				// do not sent request if promocode has expired
				if (promocodeLifetime >= extraDataPromocodeLifeInterval) {
					console.log(`Extradata promocode has expired by: ${promocodeLifetime}ms`);
					return;
				}
			}
			try {
				// send event
				const request = biDataRequestComposer(event.name, extraDataPromocode, sourceLocation);
				const response = await api.sendBiData(request);

				// process response
				if (response.status === Status.success) {
					const success = response as Success<UserPromocode>;
					const promocode = success.data.promocode;

					// if returned promocode is not the same then call updateStateData to update state
					if (promocode !== extraDataPromocode?.promocode) {
						const newPromocode: IExtraDataPromocode | null = promocode
							? {
									promocode,
									timestamp: Date.now(),
							  }
							: null;

						updateStateData(newPromocode);
					}
				} else {
					console.log(response);
					throw new AnalyticsEventsTrackerError('sendBiData request failed', 'VervBIEventsTracker');
				}
			} catch (error) {
				console.log('Error occurred while tracking event:', error);
			}
		},
	};
};
